// extracted by mini-css-extract-plugin
export default {"labelSwitch":"FormFolder_labelSwitch__mVXR6"};